export default __webpack_public_path__ + "static/media/emilse-dashboard.19d85109.png";